// Components==============
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { useMediaQ } from 'hooks/useMediaQ';
import React from 'react';
import CircleButton from '../CircleButton/CircleButton';
import './ArrowButtons.module.scss';
// =========================

type ColorOptions = 'white' | 'grey';

type Props = {
  color?: ColorOptions;
  reference: React.RefObject<HTMLDivElement>;
};

export default function ArrowButtons({ color = 'grey', reference }: Props) {
  const query = useMediaQ('min', 768);

  if (!query) return <></>;

  function viewPortBackward() {
    let width = 0;
    if (reference.current) {
      width = reference.current.clientWidth - 100;
      reference.current.scrollLeft -= width;
    }
  }
  function viewportForward() {
    let width = 0;
    if (reference.current) {
      width = reference.current.clientWidth - 100;
      reference.current.scrollLeft += width;
    }
  }

  return (
    <div styleName="arrow-buttons">
      <CircleButton
        onClick={viewPortBackward}
        color={color === 'grey' ? 'grey-blue' : 'white-blue'}
        icon={faChevronLeft}
      />
      <CircleButton
        onClick={viewportForward}
        color={color === 'grey' ? 'grey-blue' : 'white-blue'}
        icon={faChevronRight}
      />
    </div>
  );
}
